export const uploadPreviewCacheState = {
    defaultState: {
        uploadPreviewCache: {},
        uploadPreviewExpanded: {},
    },
    actions: {
        setUploadPreviewCacheEntry: ({key, src}, state) => ({
            ...state,
            uploadPreviewCache: key && src && !state.uploadPreviewCache?.[key]
                ? {...(state.uploadPreviewCache || {}), [key]: src}
                : state.uploadPreviewCache,
        }),
        setUploadPreviewExpanded: ({key, expanded}, state) => ({
            ...state,
            uploadPreviewExpanded: key
                ? {...(state.uploadPreviewExpanded || {}), [key]: expanded}
                : state.uploadPreviewExpanded,
        }),
    },
}
